module.exports = __webpack_public_path__ + "assets/backArrow.94ecaf4c.svg";